import { render, staticRenderFns } from "./lamsAbsentList.vue?vue&type=template&id=08b402c4&scoped=true&"
import script from "./lamsAbsentList.vue?vue&type=script&lang=js&"
export * from "./lamsAbsentList.vue?vue&type=script&lang=js&"
import style0 from "./lamsAbsentList.vue?vue&type=style&index=0&id=08b402c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b402c4",
  null
  
)

export default component.exports